import TourDocument, { TourProps, TourStep } from "../TourDocument/TourDocument"

export type TourModalStep = TourStep
export type TourModalProps = TourProps

const TourModal = (props: TourModalProps) => {
    return <TourDocument {...props} />
}

export default TourModal
